import { useLayoutEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { SetNewPassProps } from 'types';
import { removeLogInDataFromBrowser } from 'utils/localStoreTools';
import { openMobileApp } from 'utils/services';
import { resetPassword } from 'api';
import { SignInWrapper } from 'containers/SignWrapper';
import { DynamicForm } from 'components/DynamicForm';
import { setPassFormFields } from './formFields';

import styles from './SetNewPass.module.scss';

export const SetNewPass = (props: SetNewPassProps) => {
  const [notification, setNotification] = useState({});
  const { signInSlides, token, email } = props;
  const router = useRouter();

  useLayoutEffect(() => {
    openMobileApp(`resetpassword/${email}/${token}`);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewPassword = async (data: Record<string, string>) => {
    const response = await resetPassword({
      ...(data as { password: string; password_confirmation: string }),
      token,
      email,
    });
    if (response.ok) {
      setNotification({
        setPasswordMessage: {
          mode: 'success',
          header: 'Password reset successfully. You will be redirected to Sign In Page soon.',
        },
      });
      removeLogInDataFromBrowser();
      setTimeout(() => {
        router.push('/sign-in');
      }, 5000);
    } else {
      setNotification({
        setPasswordMessage: {
          mode: 'error',
          header: 'Server responds with error',
          message: response.message,
        },
      });
    }
  };

  return (
    <SignInWrapper slides={signInSlides}>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <DynamicForm
            onSend={setNewPassword}
            fields={setPassFormFields}
            buttonCaption="Reset Password"
            notifications={notification}
          />
        </div>
      </div>
    </SignInWrapper>
  );
};
